export const FINANCIAL_FLOW = {
    start: 'fetch_start/financial_flow',
    end: 'fetch_end/financial_flow',
    success: 'fetch_success/financial_flow',
    failed: 'fetch_failed/financial_flow',
    clear: 'clear/financial_flow'
}



// WEBPACK FOOTER //
// ./components/sankey/actions/index.js